import { Stack } from "@mui/material"
import React from "react"
import { IncidentCommentList } from "./IncidentCommentList"
import { IncidentCommentAddDialog } from "./IncidentCommentAddDialog"
import { IncidentCommentEditDialog } from "./IncidentCommentEditDialog"
import { IncidentCommentDeleteDialog } from "./IncidentCommentDeleteDialog"

function IncidentComments(){
    return <React.Fragment>
        <Stack direction='row' justifyContent='flex-end' margin='20px'>
            <IncidentCommentAddDialog/>
        </Stack>
        <IncidentCommentList/>
        <IncidentCommentEditDialog/>
        <IncidentCommentDeleteDialog/>
    </React.Fragment>
}
export {IncidentComments}